import Cart from "cart-store";
class ProductForm extends HTMLElement {
    #t;
    #e;
    static #r = [];
    constructor() {
        super(), (this.#t = this.submit.bind(this));
    }
    connectedCallback() {
        (this.#e = !1),
            setTimeout(() => {
                (this.form = this.querySelector("form")),
                    (this.idInput = this.form.querySelector('input[name="id"]')),
                    (this.submitButton = this.form.elements.add),
                    (this.stagedAction = this.querySelector("staged-action")),
                    this.idInput.removeAttribute("disabled"),
                    (this.notifyOnAdd = this.hasAttribute("notify-on-add")),
                    (this.redirectOnAdd = this.getAttribute("redirect-on-add")),
                    (this.#e = !0),
                    this.form.addEventListener("submit", this.#t);
            });
    }
    disconnectedCallback() {
        this.#e && ((this.#e = !1), this.form.removeEventListener("submit", this.#t));
    }
    async submit(t) {
        t.preventDefault();
        const e = new FormData(t.target),
            r = Object.fromEntries(e.entries());
        try {
            this.removeError(),
                this.redirectOnAdd && !ProductForm.#r.includes(this.form.id) && ProductForm.#r.push(this.form.id),
                this.stagedAction && (await this.stagedAction.setState("DOING")),
                await Cart.add(r),
                this.redirectOnAdd && ((ProductForm.#r = ProductForm.#r.filter((t) => t !== this.form.id)), 0 === ProductForm.#r.length && (window.location.href = this.redirectOnAdd)),
                this.stagedAction && (await this.stagedAction.setState("DONE"));
            const t = this.closest("quick-shop");
            if ((t && (await t.close()), this.notifyOnAdd)) {
                if ((await Cart.resetVariantsBeingAdded(), !this.closest(".modal--cart"))) {
                    const t = document.querySelector(".modal--cart, .popup--cart-notification");
                    t && !t.shown ? t.open() : t && t.interval && (t.interval.reset(), t.interval.start());
                }
            } else await Cart.resetLatestAddedProduct(), await Cart.resetVariantsBeingAdded(r.id);
        } catch (t) {
            this.#s(t.message), this.stagedAction && (await this.stagedAction.setState("IDLE")), this.redirectOnAdd && (ProductForm.#r = ProductForm.#r.filter((t) => t !== this.form.id));
        }
    }
    removeError() {
        const t = this.querySelector(".errors");
        t && t.remove();
    }
    #s(t) {
        if ((this.removeError(), this.submitButton)) {
            const e = document.createElement("div");
            e.classList.add("errors", "qty-error", "u-small"), (e.innerHTML = t), this.submitButton.before(e);
        }
    }
}
customElements.define("product-form", ProductForm);
//# sourceMappingURL=product-form.js.map
